import { differenceInCalendarDays } from 'date-fns';
import type { BrandHealthDateRange } from '@/types/brandHealth';

const MAX_REPORTING_DAYS = 366;

function utcDay(date: Date, dayOffset = 0): string {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + dayOffset)).toISOString();
}

export function toBrandHealthDateRange(startDate: Date, inclusiveEndDate: Date): BrandHealthDateRange {
  return {
    startDate: utcDay(startDate),
    endDate: utcDay(inclusiveEndDate, 1),
  };
}

export function brandHealthDateRangeError(startDate: Date, inclusiveEndDate: Date): string | null {
  const selectedDays = differenceInCalendarDays(inclusiveEndDate, startDate) + 1;
  return selectedDays > MAX_REPORTING_DAYS ? 'Date range must not exceed 366 days' : null;
}
